<template>
  <button class="button load-more" v-show="filteredRecipes.length > NrOfRecipesToShow" @click="loadMore">Load more<i class="fas fa-redo-alt"></i></button>
</template>

<script>
export default {
  methods: {
    loadMore(){
      const amount = this.$route.name == 'Search' ? 20 : 21
      this.$store.commit('setNrOfRecipesToShow', this.NrOfRecipesToShow + amount)
    }
  },
  computed:{
    NrOfRecipesToShow(){
      return this.$store.getters.nrOfRecipesToShow
    },
    filteredRecipes(){
      return this.$store.getters.filteredRecipes
    }
  }
}
</script>

<style lang="scss">
  button.load-more{
    display: block;
    font-weight: 500;
    background: var(--main);
    color: white;
    margin: 20px auto;
    padding: 10px 20px;
    font-family: 'Poppins';
    border: none;
    border-radius: 20px;
    &:focus{
      box-shadow: none !important;
      color: white;
    }
    &:hover{
      svg{
        transform: rotate(300deg);
      }
    }
    svg{
      transition: 0.3s linear all;
      width: 13px;
      height: 13px;
      margin-left: 10px;
    }
  }   
</style>